<template>
    <div>
        <el-form label-position="left" :inline="true">
            <el-form-item label="级联：" v-if="serverQueryMode == 'mode_all'">
                <el-cascader
                    @change="handleAllChange"
                    v-model="allValue"
                    placeholder="试试搜索"
                    :options="serverWorldList"
                    :props="{ multiple: true ,label: 'server_name', value: 'inner_urls', children: 'game_servers'}"
                    filterable></el-cascader>
            </el-form-item>
            <el-form-item label="世界服列表:" v-if="serverQueryMode == 'mode_world'">
                <el-select v-model="worldValue" filterable multiple placeholder="请选择" @change="handleWorldChange">
                    <el-option
                        v-for="item in serverWorldList"
                        :key="item.id"
                        :label="item.server_number + '-' + item.server_name"
                        :value="item.id + '-' + item.server_url">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="游戏服列表:" v-if="serverQueryMode == 'mode_game'">
                <el-select v-model="gameValue" filterable multiple placeholder="请选择" @change="handleGameChange">
                    <el-option
                        v-for="item in serverGameList"
                        :key="item.id"
                        :label="item.server_number + '-' + item.server_name"
                        :value="item.id + '-' + item.server_url">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选服：" v-if="serverQueryMode == 'mode_one_world_game'">
                <el-cascader
                    @change="handleOneWorldGameChange"
                    v-model="oneWorldGameValue"
                    placeholder="试试搜索"
                    :options="serverWorldList"
                    :props="{label: 'server_name', value: 'inner_urls', children: 'game_servers'}"
                    filterable></el-cascader>
            </el-form-item>
            <!-- 单个世界服 -->
            <el-form-item label="世界服列表:" v-if="serverQueryMode == 'mode_one_world'">
                <el-select v-model="oneWorldValue" filterable  placeholder="请选择" @change="handleOneWorldChange">
                    <el-option
                        v-for="item in serverWorldList"
                        :key="item.id"
                        :label="item.server_number + '-' + item.server_name"
                        :value="item.inner_urls">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 单个游戏服 -->
            <el-form-item label="游戏服列表:" v-if="serverQueryMode == 'mode__one_game'">
                <el-select v-model="oneGameValue" filterable placeholder="请选择" @change="handleOneGameChange">
                    <el-option
                        v-for="item in serverGameList"
                        :key="item.id"
                        :label="item.server_number + '-' + item.server_name"
                        :value="item.inner_urls + '#' + item.server_number">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex';

    export default {
        name: "component_server",
        data() {
            return {
                serverQueryMode: 'mode_all',
                allValue: '',
                worldValue: '',
                gameValue: '',
                oneWorldGameValue: '',
                oneWorldValue: '',
                oneGameValue: '',

                serverGameFindBO: {
                    filterConnectId: 0
                },

                loginInfoGame: [],
                sourceGameInfo: [],

                loginInfoWorld: [],
                sourceWorldInfo: [],
            }
        },
        props:['serverMode', 'isClearWorldValue'],
        watch: {
            serverMode(n,l) {
                console.log(n)
            },

            isClearWorldValue() {
                if (this.isClearWorldValue) {
                    this.worldValue = '';
                }
            }
        },
        created() {
            this.serverQueryMode = this.serverMode;
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList
            }),

        },
        mounted() {
        },
        methods: {
            selectQueryMode() {

            },

            handleAllChange(c) {
            },

            handleWorldChange(val) {
                var data = val;
                var serverWorld = [];
                data.forEach(item => {
                    serverWorld.push(item.split('-')[0])
                })
                this.$emit('worldValue',serverWorld);
            },

            handleGameChange(val) {
                var data = val;
                var serverGame = [];
                data.forEach(item => {
                    serverGame.push(item.split('-')[0])
                })
                this.$emit('gameValue',serverGame);
            },

            handleOneWorldGameChange(val) {
                var worldServer = val[0].split(';')[0];
                var gameServer = val[1].split(';')[0];
                this.$emit('worldServer',worldServer);
                this.$emit('gameServer',gameServer);
            },

            handleOneWorldChange(val) {
                var worldServer = val.split(';')[0];
                this.$emit('oneWorldServer',worldServer);
            },

            handleOneGameChange(val) {
                var urlArr = val.split('#')[0];
                var serverNumber = val.split('#')[1];

                var gameServer = urlArr.split(';')[0];
                this.$emit('oneGameServer',gameServer,serverNumber);
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/component_server.vue